module.exports = __webpack_public_path__ + "img/index-pic7.c6495ce5.webp";